<template>
  <div>
    <div class="bold" :class="classCst" :style="styleCst" @click="showUserManager">
      <span class="noselect" v-if="!clientInfo.first_name">
        ID {{ clientInfo.id }}
      </span>
      <span class="noselect" v-else>
        {{ clientInfo.first_name }} {{ clientInfo.last_name }}
      </span>
    </div>

    <span class="noselect small" v-if="telephone">
      {{ formattedTelephone }}
    </span>
  </div>
</template>

<script>
export default {
  name: "UserManagerHandler",
  props: {
    clientInfo: Object,
    dti: Boolean,
    styleCst: [String, null],
    classCst: [String, null],
    rules: [Array, null],
    mortgageLayout: Boolean,
    client: Boolean,
    clients: Boolean,
    detail: Boolean,
    telephone: Boolean,
    mortgages: [Object, Boolean, null],
  },

  computed: {
    formattedTelephone() {
      let tel = this.clientInfo?.client_profile?.telephone || "";

      // odstrániť +421 a nahradiť 0
      if (tel.startsWith("+421")) {
        tel = "0" + tel.slice(4);
      }

      // formátovanie: 0950 880 132
      return tel.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3");
    },
  },

  methods: {
    showUserManager() {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: {
          detail: this.detail,
          clients: this.clients,
          client: this.client,
          mortgage: this.mortgages,
          mortgageLayout: this.mortgageLayout
        },
        payload: this.clientInfo,
        component: "UserManagerPopUp",
        rules: this.rules,
      });
    },
  },
};
</script>